import React from 'react';
import { Link } from 'react-router-dom';

function Logo(props) {
  return (
    <div className="tv-left-pannel__logo">
      <Link to="/" className="logo-link">
        <img src="/images/logo.png" alt="logo image" id="logo-image" />
      </Link>
    </div>
  );
}

export default Logo;
